import { BackendClient, type BackendTypes } from '@tf/api';

export const instantCheckQuery = async (
	input: BackendTypes.AdhocSearchParams,
): Promise<BackendTypes.AdhocSearchData> => {
	const res = await BackendClient.getInstance().adhocSearch(input);
	return res.json();
};
